export default "__VITE_ASSET__BSEjXbEb__"